import { LocalizationProvider } from '@mui/lab';
import { Provider as ReduxProvider } from 'react-redux';
import { CssBaseline } from '@mui/material';
import { Toaster } from 'react-hot-toast';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import esLocale from 'date-fns/locale/es';

import { store } from 'store';
import { AuthConsumer, AuthProvider } from 'auth';
import { ThemeProvider } from 'theme';
import SplashScreen from 'components/SplashScreen';
import Router from 'Router';

const App = () => {
  return (
    <ReduxProvider store={store}>
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={esLocale}>
        <AuthProvider>
          <ThemeProvider>
            <CssBaseline />
            <Toaster position='bottom-right' />
            <AuthConsumer>
              {(auth) => (!auth.isInitialized ? <SplashScreen /> : <Router />)}
            </AuthConsumer>
          </ThemeProvider>
        </AuthProvider>
      </LocalizationProvider>
    </ReduxProvider>
  );
};

export default App;
